import { cva, type VariantProps } from "./style.utils";

export type FieldLabelVariants = VariantProps<typeof fieldLabelVariants>;

export const fieldLabelVariants = cva({
  base: "block text-sm leading-none",
});
